import { appConfig } from 'client/core/appConfig';
import { joinPath } from 'client/core/network/joinPath';
import qs from 'qs';

export function getSsoRedirectUrl(
  strategy: string,
  identityProvider?: string
): string {
  const baseUrl = joinPath([appConfig.publicPath, process.env.REST_URL]);
  const query = qs.stringify({
    identityProvider
  });
  return `${baseUrl}/auth/openweb/${strategy}/sso?${query}`;
}
